export default __webpack_public_path__ + "static/media/courier.8608e41c.png";